import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

export type MasterCheckboxState = 'unchecked' | 'indeterminate' | 'checked';

@Component({
  selector: 'es-line-items-bulk-delete-modal',
  templateUrl: './es-line-items-bulk-delete-modal.component.html',
  styleUrls: ['./es-line-items-bulk-delete-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EsLineItemsBulkDeleteModalComponent {
  @Input() public isOpen: boolean = false;
  @Input() public isLoading: boolean = false;

  @Output() public confirmed: EventEmitter<void> = new EventEmitter<void>();
  @Output() public cancelled: EventEmitter<void> = new EventEmitter<void>();

  public onCancel(): void {
    if (this.isLoading) {
      return;
    }
    this.cancelled.emit();
  }

  public onConfirm(): void {
    if (this.isLoading) {
      return;
    }
    this.confirmed.emit();
  }
}
